import * as React from 'react';

export const CollapsedSmallIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99991 12.5012C9.78658 12.5012 9.57322 12.4196 9.41072 12.2571L6.07738 8.92374C5.75155 8.5979 5.75155 8.07118 6.07738 7.74535C6.40322 7.41952 6.92993 7.41952 7.25577 7.74535L9.99991 10.4895L12.744 7.74535C13.0699 7.41952 13.5966 7.41952 13.9224 7.74535C14.2483 8.07118 14.2483 8.5979 13.9224 8.92374L10.5891 12.2571C10.4266 12.4196 10.2132 12.5012 9.99991 12.5012Z"
      fill="black"
    />
  </svg>
);
